import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom";
import styles from "./dash.module.scss";
import { useNavigate } from "react-router-dom";

import basketballIcon from "../../assets/nba.svg";
import footballIcon from "../../assets/nfl.svg";
import baseballIcon from "../../assets/mlb.svg";
import soccerIcon from "../../assets/fc.svg";
import tennisIcon from "../../assets/nhl.svg";
import PageHeader from "../PageHeader/PageHeader";
import PageInfo from "../PageInfo/PageInfo";
import ReactGA from "react-ga";
import { Link } from "react-router-dom";
import gridsIcon from "../../assets/grids-icon.png";
import triviaIcon from "../../assets/trivia-icon.png";
import guessPlayerIcon from "../../assets/guess-player-icon.png";
import guessTeamIcon from "../../assets/guess-team-icon.png";
import googlePlayImg from '../../assets/google-play.webp';
import appleAppImg from '../../assets/apple-app.webp';

const sportsData = [
  {
    id: 1,
    name: "Basketball",
    emoji: "🏀",
    icon: basketballIcon,
    gameModes: [
      { id: 1, name: "Trivia" },
      { id: 2, name: "Grids" },
      { id: 3, name: "Connections" },
      { id: 4, name: "Random-Generator" },
      { id: 7, name: "Multiplayer", route: "/play" },
    ],
  },
  {
    id: 2,
    name: "Football",
    emoji: "🏈",
    icon: footballIcon,
    gameModes: [
      { id: 1, name: "Trivia" },
      { id: 2, name: "Grids" },
      { id: 3, name: "Connections" },
      { id: 4, name: "Random-Generator" },
      { id: 5, name: "Guesser" },
      { id: 6, name: "Multiplayer", route: "/play" },
    ],
  },
  {
    id: 3,
    name: "Baseball",
    emoji: "⚾",
    icon: baseballIcon,
    gameModes: [
      { id: 1, name: "Trivia" },
      { id: 2, name: "Grids" },
      { id: 3, name: "Connections" },
      { id: 4, name: "Multiplayer", route: "/play" },
    ],
  },
  {
    id: 100,
    name: "Geography",
    emoji: "🌍",
    icon: soccerIcon,
    gameModes: [{ id: 2, name: "Grids" }],
  },
  {
    id: 4,
    name: "Soccer",
    emoji: "⚽",
    icon: soccerIcon,
    gameModes: [
      { id: 1, name: "Trivia" },
      { id: 2, name: "Grids" },
    ],
  },
  {
    id: 5,
    name: "Hockey",
    emoji: "🏒",
    icon: tennisIcon,
    gameModes: [
      { id: 1, name: "Grids" },
      { id: 2, name: "Connections" },
      { id: 3, name: "Guesser" },
      { id: 4, name: "Multiplayer", route: "/play" },
    ],
  },
  {
    id: 6,
    name: "Golf",
    emoji: "⛳",
    icon: footballIcon,
    gameModes: [{ id: 2, name: "Grids" }],
  },
  {
    id: 7,
    name: "WWE",
    emoji: "🤼",
    icon: footballIcon,
    gameModes: [{ id: 2, name: "Grids" }],
  },
  {
    id: 8,
    name: "Movies",
    emoji: "🎬",
    icon: footballIcon,
    gameModes: [
      { id: 2, name: "Grids" },
      { id: 3, name: "Movie Quest" },
    ],
  },
  {
    id: 9,
    name: "F1",
    emoji: "🏎️",
    icon: footballIcon,
    gameModes: [{ id: 2, name: "Grids" }],
  },
  {
    id: 10,
    name: "College Basketball",
    emoji: "🎓🏀",
    icon: footballIcon,
    gameModes: [{ id: 2, name: "Grids" }],
  },
  {
    id: 11,
    name: "College Football",
    emoji: "🎓🏈",
    icon: footballIcon,
    gameModes: [{ id: 2, name: "Grids" }],
  },
  {
    id: 12,
    name: "Pokemon",
    emoji: "🐉",
    icon: footballIcon,
    gameModes: [{ id: 1, name: "Multiplayer", route: "/play" }],
  },
];


const games = [
  {
    id: "Grids",
    name: "Grids",
    description: "Fill a 3x3 grid with the correct criteria",
    icon: gridsIcon,
    link: "/",
  },
  {
    id: "Multiplayer",
    name: "Multiplayer",
    description: "Play others in live unlimited tic-tac-toe grids",
    icon: "https://www.nytimes.com/games-assets/v2/assets/expansion-games/vertex-card-icon.svg",
    link: "/multiplayer",
    badge: "Now works!",
  },
  {
    id: "Trivia",
    name: "Trivia",
    description: "Select the leaders in order for the provided criteria",
    icon: triviaIcon,
    link: "/nba/trivia",
  },
  {
    id: "Guesser",
    name: "Guess The Player",
    description: "Guess the player based on their career path",
    icon: guessPlayerIcon,
    link: "/guess-player",
  },
  {
    id: "Random-Generator",
    name: "Random-Generator",
    description: "Identify players by their career journey",
    icon: guessTeamIcon,
    link: "/nba/random-generator",
  },
  {
    id: "Connections",
    name: "Connections",
    description: "Find the connections between concepts",
    icon: "https://www.nytimes.com/games-assets/v2/assets/expansion-games/connections.svg",
    link: "/connections",
  },
/*   {
    id: "AI",
    name: "AI",
    description:
      "Explore the convergence of sports and comparisons between other sports",
    icon: "https://www.nytimes.com/games-assets/v2/assets/expansion-games/vertex-card-icon.svg",
    color: "#C8AAE5",
  }, */
];

const GameCard = ({ id, name, description, icon, onClick, onPlay, isDarkMode, badge }) => (
  <div className={styles.gameCard} onClick={() => onClick(id)} style={{
    backgroundColor: isDarkMode ? "#2C2C2E" : "#fff",
    color: isDarkMode ? "#F0F0F0" : "#000",
  }}>
    <img src={icon} alt={`${name} icon`} className={styles.gameIcon} />
    <h3 className={styles.gameTitle}>
      {name}
      {badge && (
        <span style={{
          marginLeft: '8px',
          padding: '2px 8px',
          fontSize: '12px',
          fontWeight: 'bold',
          backgroundColor: '#4CAF50',
          color: '#fff',
          borderRadius: '12px',
          verticalAlign: 'middle',
        }}>
          {badge}
        </span>
      )}
    </h3>
    <p className={styles.gameDescription}>{description}</p>
    <div className={styles.gameActions}>
      {name !== "Multiplayer" && (
        <div
          className={`${styles.gameButton} ${styles.modernButton}`}
          onClick={() => onPlay(id)}
          tabIndex="0"
        >
          Play
         </div>
      )}
      {id === "spelling-bee" && (
        <Link to={`/${id}/past`} className={`${styles.gameButton} ${styles.modernButton}`}>
          Past Puzzles
        </Link>
      )}
    </div>
  </div>
);

const GamesContainer = ({ onClick, onPlay, isDarkMode }) => (
  <div className={styles.gamesContainer}>
    {games.map((game) => (
      <GameCard key={game.id} {...game} onClick={onClick} onPlay={onPlay} isDarkMode={isDarkMode} />
    ))}
  </div>
);

const SportCard = ({ id, name, emoji, icon, gameModes, isDarkMode }) => (
  <div className={styles.sportCard} style={{
    backgroundColor: isDarkMode ? "#2C2C2E" : "#fff",
    color: isDarkMode ? "#F0F0F0" : "#000",
  }}>
    <div className={styles.sportIconContainer}>
      <img src={icon} alt={`${name} icon`} className={styles.sportIcon} />
    </div>
    <div className={styles.sportContent}>
      <h3 className={styles.sportTitle}>
        <span role="img" aria-label={name} className={styles.sportEmoji}>
          {emoji}
        </span>{" "}
        {name}
      </h3>
      <div className={styles.gameModes}>
        {gameModes.map((mode) => (
          <Link
            to={`/${id}/${mode.id}`}
            key={mode.id}
            className={`${styles.playButton} ${styles.modernButton}`}
          >
            {mode.name}
          </Link>
        ))}
      </div>
    </div>
  </div>
);

const SportsContainer = ({ sports, isDarkMode }) => (
  <div className={styles.sportsContainer}>
    {sports.map((sport) => (
      <SportCard key={sport.id} {...sport} isDarkMode={isDarkMode} />
    ))}
  </div>
);

const SportsPicker = ({ sports, showAll, onToggleShowMore, onSelectSport, isDarkMode }) => (
  <div className={styles.sportsPicker}>
    <div className={styles.pickerContent}>
          <h2 className={styles.pickerTitle} style={{ color: isDarkMode ? "#F0F0F0" : "#1a1a1a" }}>Discover Daily & Unlimited Trivia</h2>
          <div className={styles.pickerItems}>
            {sports.slice(0, showAll ? sports.length : 5).map((sport) => (
              <button
                key={sport.id}
                className={styles.sportPickerItem}
                onClick={() => onSelectSport(sport)}
                aria-label={`Select ${sport.name}`}
              >
                <img src={sport.icon} alt={sport.name} style={{ width: '20px', height: '20px', marginRight: '8px' }} />
                {sport.name}
              </button>
            ))}
      </div>
      <button className={styles.showMoreButton} onClick={onToggleShowMore}>
        {showAll ? "Show Less" : "More Sports"}
      </button>
    </div>
  </div>
);

const CustomDialog = ({
  isOpen,
  onClose,
  title,
  content,
  isDarkMode,
}) => {
  if (!isOpen) return null;

  const modalContent = (
    <div
      className={styles.dialogOverlay}
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div
        className={styles.dialog}
        style={{
          backgroundColor: isDarkMode ? "#1c1c1e" : "#fff",
          color: isDarkMode ? "#f5f5f5" : "#1c1c1e",
        }}
      >
        <div className={styles.dialogHeader}>
          <h2 className={styles.dialogTitle}>{title}</h2>
          <button
            className={styles.dialogCloseX}
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
        </div>
        <div className={styles.dialogContent}>{content}</div>
      </div>
    </div>
  );

  // Use React Portal to render modal at document body level
  return ReactDOM.createPortal(
    modalContent,
    document.body
  );
};

const SportsPage = () => {
  const [showAll, setShowAll] = useState(false);
  const [isSportDialogOpen, setIsSportDialogOpen] = useState(false);
  const [isGameModeDialogOpen, setIsGameModeDialogOpen] = useState(false);
  const [selectedGameMode, setSelectedGameMode] = useState({});
  const [selectedSport, setSelectedSport] = useState({ gameModes: [] });
  const [filteredSports, setFilteredSports] = useState([]);
  const [isDarkMode, setIsDarkMode] = useState(false); // Initially set to false to test light mode
  const navigate = useNavigate();

  useEffect(() => {
    const mediaQuery = window.matchMedia("(prefers-color-scheme: dark)");
    setIsDarkMode(mediaQuery.matches);

    const handleChange = (e) => setIsDarkMode(e.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  const toggleDarkMode = () => {
    setIsDarkMode(!isDarkMode);
  };

  const navigateToGameModeForSport = (sportId) => {
    const sport = sportsData.find((sport) => sport.id === sportId);

    if (!sport) {
      console.error("Sport not found with id:", sportId);
      return;
    }

    if (!selectedGameMode || !selectedGameMode.name) {
      console.error("Selected game mode is not defined");
      return;
    }

    const urlMap = {
      1: "/nba",
      2: "/nfl",
      3: "/mlb",
      4: "/soccer",
      5: "/nhl",
      6: "/golf",
      7: "/wrestling",
      8: "/movies",
      9: "/racing",
      10: "/cfb",
      11: "/cbb",
      100: "/geography",
    };

    let url = urlMap[sportId] || "/nba";

    if (selectedGameMode.name === "Grids") {
      navigate(url);
    } else if (
      ["Connections", "Trivia", "Random-Generator", "Guesser"].includes(
        selectedGameMode.name
      )
    ) {
      url += `/${selectedGameMode.name.toLowerCase()}`;
      navigate(url);
    } else if (selectedGameMode.name === "Movie Quest") {
      navigate("/unlimited");
    } else {
      setSelectedGameMode(selectedGameMode);
      setIsGameModeDialogOpen(true);
    }

    setShowGameModeSportsDialog(false);
  };

  const handleToggleShowMore = () => {
    setShowAll(!showAll);
  };

  const handleOpenSportDialog = (sport) => {
    setSelectedSport(sport);
    setIsSportDialogOpen(true);
  };

  const [showGameModeSportsDialog, setShowGameModeSportsDialog] =
    useState(false);
  const [sportsForGameMode, setSportsForGameMode] = useState([]);
  const handlePlayClick = (gameModeName) => {
    const filteredSports = sportsData.filter((sport) =>
      sport.gameModes.some((mode) => mode.name === gameModeName)
    );
    setSelectedGameMode(gameModeName);
    setSportsForGameMode(filteredSports);
    setShowGameModeSportsDialog(true);
  };

  const handleGameModeClick = (gameModeName) => {
    if (gameModeName === "Multiplayer") {
      navigate("/play");
      return;
    }

    setSelectedGameMode({ name: gameModeName });

    const filteredSports = sportsData.filter((sport) =>
      sport.gameModes.some((mode) => mode.name === gameModeName)
    );
    setSportsForGameMode(filteredSports);
    setShowGameModeSportsDialog(true);
  };

  const handleCloseGameModeSportsDialog = () => {
    setIsGameModeDialogOpen(false);
  };

  const handleCloseGameModeDialog = () => {
    setIsGameModeDialogOpen(false);
  };
  const handleOpenGameModeDialog = (gameMode, sportId) => {
    // Check if the selected game mode is "Multiplayer"
    if (gameMode.name === "Multiplayer") {
      navigate("/play");
      return; // Ensure no further logic is executed
    }

    const urlMap = {
      1: "/nba",
      2: "/nfl",
      3: "/mlb",
      4: "/soccer",
      5: "/nhl",
      6: "/golf",
      7: "/wrestling",
      8: "/movies",
      9: "/racing",
      10: "/cfb",
      11: "/cbb",
      100: "/geography",
    };

    let url = urlMap[sportId] || "/nba";
  
    if (gameMode.name === "Grids") {
      navigate(url);
    } else if (
      ["Connections", "Trivia", "Random-Generator", "Guesser"].includes(
        gameMode.name
      )
    ) {
      url += `/${gameMode.name.toLowerCase()}`;
      navigate(url);
    } else if (gameMode.name === "Movie Quest") {
      navigate("/unlimited");
    } else {
      setSelectedGameMode(gameMode);
      setIsGameModeDialogOpen(true);
    }
  };
  
  const onAdRefresh = () => {
    window.freestar?.queue.push(function () {
      window.freestar?.newStickyFooter("crossovergrid_sticky_footer");
      window.freestar?.refresh("crossovergrid_sidewall_left");
      window.freestar?.refresh("crossovergrid_sidewall_right");
    });
  };

  useEffect(() => {
    onAdRefresh();
  }, []);

  return (
    <div
      className={styles.sportsPage}
      style={{
        background: isDarkMode 
          ? "linear-gradient(180deg, #1a1a2e 0%, #0f0f1a 100%)" 
          : "linear-gradient(180deg, #f8f9fa 0%, #e9ecef 100%)",
        color: isDarkMode ? "#f8f9fa" : "#212529",
        minHeight: "100vh",
      }}
    >
      <PageInfo
        title="Crossover Grid: Daily Sports Trivia Games"
        metaTitle="Crossover Grid: Daily Sports Trivia Games"
        metaDescription="Play daily sports trivia games including NBA, NFL, MLB, NHL, Soccer grids, trivia, connections, and more. Test your sports knowledge with new challenges every day!"
        metaUrl="/"
        keywords={[
          "crossover grid",
          "sports trivia",
          "daily trivia game",
          "nba grid",
          "nfl grid",
          "mlb grid",
          "nhl grid",
          "soccer grid",
          "sports connections",
          "immaculate grid",
          "daily sports game"
        ]}
        twitterCreator="@CrossoverGrid"
      />
      <PageHeader />
      <div className={styles.announcementBanner}>
        <div className={styles.announcementText}>
          <span style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            Introducing our mobile app
            <img
              src="https://play-lh.googleusercontent.com/MN50gnjQdljC65YVYemVn-X8I5QmUBgBOsx55zbHzkfuO4IqIblSCqlHCjTnj6ItH4Q=w480-h960-rw"
              alt="App Logo"
              style={{ height: '24px', width: '24px', borderRadius: '4px' }}
            />
          </span>
          Play on iOS and Android for daily and exclusive trivia.
        </div>
        <div className={styles.buttonContainer}>
          <a
            href="https://apps.apple.com/us/app/crossover-games/id6744907407"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.appStoreLink}
          >
            <img src={googlePlayImg} alt="Download on the App Store" style={{ height: 44, width: 'auto', display: 'block' }} />
          </a>
          <a
            href="https://play.google.com/store/apps/details?id=com.crossover.sports&hl=en_US"
            target="_blank"
            rel="noopener noreferrer"
            className={styles.appStoreLink}
          >
            <img src={appleAppImg} alt="Get it on Google Play" style={{ height: 44, width: 'auto', display: 'block' }} />
          </a>
        </div>
      </div>
      <div className={styles.pageContentWrapper}>
        <div className={styles.mainContent}>
          <SportsPicker
            sports={sportsData}
            showAll={showAll}
            onToggleShowMore={handleToggleShowMore}
            onSelectSport={handleOpenSportDialog}
            isDarkMode={isDarkMode}
          />
          <div className={styles.gamesContainer}>
            <div className={styles.gamesGrid}>
              {games.map((game) => (
                <div
                  key={game.id}
                  className={styles.gameCardLink}
                  onClick={() => handleGameModeClick(game.id)}
                  style={{ cursor: 'pointer' }}
                >
                  <div className={styles.gameCardCover}>
                    <div
                      className={styles.gameCardIllustration}
                      style={{
                        backgroundImage: `url(${game.icon})`,
                      }}
                    />
                    <h4 className={styles.gameCardName}>
                      {game.name}
                      {game.badge && (
                        <span style={{
                          marginLeft: '8px',
                          padding: '2px 8px',
                          fontSize: '11px',
                          fontWeight: 'bold',
                          backgroundColor: '#4CAF50',
                          color: '#fff',
                          borderRadius: '12px',
                          verticalAlign: 'middle',
                        }}>
                          {game.badge}
                        </span>
                      )}
                    </h4>
                  </div>
                  <div className={styles.gameCardContent}>
                    <p className={styles.gameCardDescription}>
                      {game.description}
                    </p>
                    <div className={styles.gameCardButton}>Play</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
        <footer className={styles.footer}>
          <div className={styles.footerContent}>
            <div className={styles.footerSection}>
              <h4 className={styles.footerBrand}>Crossover Grid</h4>
              <p className={styles.footerTagline}>Daily sports trivia games for true fans.</p>
              <div className={styles.footerAppLinks}>
                <a href="https://apps.apple.com/us/app/crossover-games/id6744907407" target="_blank" rel="noopener noreferrer">App Store</a>
                <a href="https://play.google.com/store/apps/details?id=com.crossover.sports&hl=en_US" target="_blank" rel="noopener noreferrer">Google Play</a>
              </div>
            </div>
            <div className={styles.footerSection}>
              <h5 className={styles.footerTitle}>Basketball</h5>
              <nav className={styles.footerNav}>
                <a href="/nba">NBA Grid</a>
                <a href="/nba/trivia">NBA Trivia</a>
                <a href="/nba/guesser">Guess The Player</a>
                <a href="/nba/connections">Connections</a>
              </nav>
            </div>
            <div className={styles.footerSection}>
              <h5 className={styles.footerTitle}>Football</h5>
              <nav className={styles.footerNav}>
                <a href="/nfl">NFL Grid</a>
                <a href="/nfl/trivia">NFL Trivia</a>
                <a href="/nfl/guesser">Guess The Player</a>
                <a href="/nfl/connections">Connections</a>
              </nav>
            </div>
            <div className={styles.footerSection}>
              <h5 className={styles.footerTitle}>Baseball</h5>
              <nav className={styles.footerNav}>
                <a href="/mlb">MLB Grid</a>
                <a href="/mlb/trivia">MLB Trivia</a>
                <a href="/mlb/connections">Connections</a>
              </nav>
            </div>
            <div className={styles.footerSection}>
              <h5 className={styles.footerTitle}>More</h5>
              <nav className={styles.footerNav}>
                <a href="/nhl">Hockey Grid</a>
                <a href="/soccer">Soccer Grid</a>
                <a href="/cbb">College Basketball</a>
                <a href="/cfb">College Football</a>
                <a href="/multiplayer">Multiplayer</a>
              </nav>
            </div>
            <div className={styles.footerSection}>
              <h5 className={styles.footerTitle}>Company</h5>
              <nav className={styles.footerNav}>
                <a href="/privacypolicy">Privacy Policy</a>
                <a href="mailto:feedback@crossovergrid.com">Contact</a>
              </nav>
            </div>
          </div>
          <div className={styles.footerBottom}>
            <span>© 2025 Crossover Sports Entertainment LLC. All rights reserved.</span>
          </div>
        </footer>

        <CustomDialog
          isOpen={isSportDialogOpen}
          onClose={() => setIsSportDialogOpen(false)}
          title={`Choose a ${selectedSport.name} Game Mode`}
          content={
            <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
              {selectedSport.gameModes && selectedSport.gameModes.length > 0 ? (
                selectedSport.gameModes.map((mode) => (
                  <button
                    key={`sport-mode-${mode.id}`}
                    className={styles.gameModeButton}
                    onClick={() => {
                      setIsSportDialogOpen(false);
                      handleOpenGameModeDialog(mode, selectedSport.id);
                    }}
                  >
                    {mode.name}
                  </button>
                ))
              ) : null}
            </div>
          }
          isDarkMode={isDarkMode}
        />

        <CustomDialog
          isOpen={showGameModeSportsDialog}
          onClose={() => setShowGameModeSportsDialog(false)}
          title={`Select a Sport for ${selectedGameMode.name}`}
          content={
            <div className={styles.sportsOptions}>
              {sportsForGameMode.map((sport, index) => (
                <button
                  key={sport.id}
                  className={styles.gameModeButton}
                  onClick={() => navigateToGameModeForSport(sport.id)}
                >
                  {sport.name}
                </button>
              ))}
            </div>
          }
          isDarkMode={isDarkMode}
        />
      </div>
    </div>
  );
};

export default SportsPage;
